import { Button, Row, Col } from "antd";
import { Link } from "react-router-dom";

const QuickAccessOptions = () => {
  return (
    <Row justify="space-between" gutter={[24, 24]}>
      <Col xs={12} sm={12} md={12} lg={8}>
        <Link to="/company/company-profile/edit-profile/">
          <Button type="default" size="large" style={{ width: "100%" }}>
            Rediger profil
          </Button>
        </Link>
      </Col>

      <Col xs={12} sm={12} md={12} lg={8}>
        <Link to="/company/company-profile/jobs/create-job-posting/">
          <Button type="default" size="large" style={{ width: "100%" }}>
            Ny stillingsannonse
          </Button>
        </Link>
      </Col>

      <Col xs={24} sm={24} md={24} lg={8}>
        <Link to="/company/event-booking/">
          <Button style={{ background: "var(--secondary-color)", color: "var(--light)", width: "100%" }} size="large">
            Book arrangement
          </Button>
        </Link>
      </Col>
    </Row>
  );
};

export default QuickAccessOptions;
